import * as React from 'react';
import Stack from '@mui/material/Stack';
import { useReactiveVar } from '@apollo/client';
import _ from 'lodash';
import * as Device from 'react-device-detect';

import { conversationIdVar } from '@context';
import { useSession } from '@hooks';
import { useGetConversationInfosQuery } from '@graphql';
import { Conversation, Header } from './components';

interface ConversationDialogProps {
  handleCloseDialog: () => void;
}

export function ConversationDialog(props: Readonly<ConversationDialogProps>) {
  const { handleCloseDialog } = props;
  const inputRef = React.useRef<HTMLInputElement | null>(null);
  const { user, account } = useSession();
  const conversationId = useReactiveVar(conversationIdVar);

  const { data } = useGetConversationInfosQuery({
    skip: !account || conversationId === null,
    variables: {
      conversationId: conversationId ?? '',
    },
  });

  React.useEffect(() => {
    // only focus if the dialog is open AND we have a conversation loaded
    if (Device.isDesktop && conversationId !== null && data?.conversation) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  }, [conversationId, data?.conversation]);

  if (!user || conversationId === null || !data?.conversation) {
    return null;
  }

  return (
    <Stack
      p={0}
      pt="env(safe-area-inset-top)"
      pb="env(safe-area-inset-bottom)"
      width="100%"
      height="100%"
      minHeight={0}
      sx={{ overflow: 'hidden' }}
    >
      <Header conversation={data.conversation} handleCloseDialog={handleCloseDialog} />
      <Conversation conversationId={conversationId} />
    </Stack>
  );
}
